import { render, staticRenderFns } from "./AppBarComponent.vue?vue&type=template&id=20f8565b"
import script from "./AppBarComponent.vue?vue&type=script&lang=js"
export * from "./AppBarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports